import React, { useRef, useState, useEffect } from 'react';
import { Field, Formik, Form } from 'formik';
import { TextInput, Dropdown } from '../../../../components';
import { Checkbox, FormControlLabel } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import Constants from '../../../../Constants';
import { storePainAndSufferingData } from '../../../../redux/actions/painAndSuffering';
import XMultiImageUpload from "./XMultiImageUpload";
import { cancelCaseSubmission, formikRefCapture, isCaseSaved } from '../../../../redux/actions/liabilty';
import { handleEnterKeyPress } from "../../../../utils/handleEnterKey";
import CaseFormFooter from "../../../../components/ui-control/CaseFormFooter";

const PainAndSufferingAnalysisForm = ({ onSubmit, stepDecrement, backToCases, innerRef,plainTiffs,selectedTiffIndex, formSteps, setPlainTiffs }) => {
    const dispatch = useDispatch();
    const DamageData = useSelector(state => state.painAndSuffering.painAndSufferingData);
    const painPoints = useRef([
        {
            category: "Personal Care",
            points: ["Self Bathing", "Self Dressing", "Self Grooming", "Putting on Shoes"],
        },
        {
            category: "Fitness and Recreation",
            points: ["Walking", "Running", "Going to the Gym", "Youth Sports"],
        },
        {
            category: "Leisure and Rest",
            points: ["Sleep", "Sex Life", "Family Vacations"],
        },
        {
            category: "Household Tasks",
            points: ["Cleaning", "Dishes", "Laundry", "Taking Out Trash", "Raking Leaves / Shoveling Snow", "Yardwork", "Car Maintenance", "Grocery Shopping", "Gardening"],
        },
        {
            category: "Family and Relationships",
            points: ["Relationship with Spouse", "Relationship with Children", "Relationship with Grandchildren", "Holding Children", "Family Play Time", "Family Outings"],
        },
    ]);
    const [bulletText, setBulletText] = useState(new Array(plainTiffs.length).fill(""));
    const textareaRef = useRef(null);
    const [bodilyInjuriesImageFiles, setBodilyInjuriesImageFiles] = useState(new Array(plainTiffs.length).fill([]));
    useEffect(() => {
        dispatch(formikRefCapture(innerRef))
    }, [])


    useEffect(() => {
        if (DamageData.painAndSufferingArr) {
            setBodilyInjuriesImageFiles(Array.from({length:plainTiffs.length},(_,index)=>{
                return DamageData.painAndSufferingArr[index]?.bodilyInjuriesImageFiles || []
            }))
            setBulletText(Array.from({length:plainTiffs.length},(_,index)=>{
                return DamageData.painAndSufferingArr[index]?.descriptionText || "" 
            }))
        }
    }, [DamageData])


    const handleAddBullet = (isNewLine = false) => {
        const textarea = textareaRef.current;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const bullet = '\u2022 ';
        const newText = bulletText[selectedTiffIndex].slice(0, start) + (isNewLine ? '\n' : '') + bullet + bulletText[selectedTiffIndex].slice(end);
        setBulletText(prev => {
            const updated = [...prev];
            updated[selectedTiffIndex] = newText;
            return updated;
          });
        textarea.focus();
    };

    const handleKeyDown = (e) => {
        const bullet = '\u2022 ';
        if (e.key === 'Enter') {
            e.preventDefault();
            handleAddBullet(true);
        } else if (bulletText[selectedTiffIndex].length === 0) {
            setBulletText(prev => {
                const updated = [...prev];
                updated[selectedTiffIndex] = bullet;
                return updated;
            });
        }
    };


    const bodilyInjuriesFilesOnChange = (files) => {
        setBodilyInjuriesImageFiles(prev => {
            const updated = [...prev];
            updated[selectedTiffIndex] = files;
            return updated;
        });
    }

    const saveDataToStore = (values = {}) => {
        values.painAndSufferingArr.forEach((elem,index)=>{
            elem.descriptionText = bulletText[index] || ""
            elem.bodilyInjuriesImageFiles = bodilyInjuriesImageFiles[index] || [] 
        });
        dispatch(storePainAndSufferingData(values));
        return values
    }

    const handlePrevious = (values) => {
        saveDataToStore(values);
        stepDecrement();
    };

    const painAndSufferingArr = DamageData?.painAndSufferingArr ?? [];
    return (
        <Formik
            initialValues={{
                painAndSufferingArr : Array.from({ length: plainTiffs.length }, (_, i) => {
                    const existingPainData= painAndSufferingArr?.[i] || {};
                    // Use age/gender from plainTiffs' personalInfo as source of truth
                    return {
                        monthlyamount: existingPainData.monthlyamount || '',
                        annualamount: existingPainData.annualamount || '',
                        gender: plainTiffs[i]?.personalInfo?.gender || '',
                        age: plainTiffs[i]?.personalInfo?.age || '',
                        descriptionText: existingPainData.descriptionText || '',
                        selectedPainPoints: Array.isArray(existingPainData.selectedPainPoints) ? [...existingPainData.selectedPainPoints] : []
                    };
                })
            }}
            enableReinitialize={true}
            onSubmit={(values) => {
                dispatch(cancelCaseSubmission(true))
                dispatch(isCaseSaved(false))
                setPlainTiffs(prev => {
                    const updated = [...prev];
                    values.painAndSufferingArr.forEach((item, idx) => {
                        updated[idx] = {
                            ...updated[idx],
                            personalInfo: {
                                ...updated[idx].personalInfo,
                                age: item.age,
                                gender: item.gender
                            }
                        };
                    });
                    return updated;
                });
                console.log("Updated plaintiffs: ",plainTiffs);
                const updatedFormValues = saveDataToStore(values);
                onSubmit({
                    painAndSuffering: updatedFormValues,
                    isDraftCase: false
                })
            }}
        >
            {({ values,setFieldValue }) => (
                <Form
                    onKeyDown={(e) => handleEnterKeyPress(e)}
                >
                    <div className="add-form p-0">
                        <div className='form-background form-item-pd'>
                        <h3 className="form-title mb-6 fs-4">Pain and Suffering Calculation</h3>
                        
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <Field name={`painAndSufferingArr[${selectedTiffIndex}].age`} placeholder="Write age..." label="Age" type="number" component={TextInput} 
                                            value={plainTiffs[selectedTiffIndex]?.personalInfo?.age || ''}
                                            onChange={e => {
                                                setFieldValue(`painAndSufferingArr[${selectedTiffIndex}].age`, e.target.value);
                                                // Update Redux painAndSuffering data with current Formik values before updating plainTiffs
                                                dispatch(storePainAndSufferingData({
                                                    painAndSufferingArr: values.painAndSufferingArr.map((item, idx) =>
                                                        idx === selectedTiffIndex ? { ...item, age: e.target.value } : item
                                                    )
                                                }));
                                                setPlainTiffs(prev => {
                                                    const updated = [...prev];
                                                    updated[selectedTiffIndex] = {
                                                        ...updated[selectedTiffIndex],
                                                        personalInfo: {
                                                            ...updated[selectedTiffIndex].personalInfo,
                                                            age: e.target.value
                                                        }
                                                    };
                                                    return updated;
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <Field name={`painAndSufferingArr[${selectedTiffIndex}].gender`}
                                            label="Gender"
                                            component={Dropdown}
                                            defaultOption="Select Gender"
                                            options={Constants.Dropdowns.MrMrs}
                                            className="w-100"
                                            value={plainTiffs[selectedTiffIndex]?.personalInfo?.gender || ''}
                                            onChange={e => {
                                                setFieldValue(`painAndSufferingArr[${selectedTiffIndex}].gender`, e.target.value);
                                                // Update Redux painAndSuffering data with current Formik values before updating plainTiffs
                                                dispatch(storePainAndSufferingData({
                                                    painAndSufferingArr: values.painAndSufferingArr.map((item, idx) =>
                                                        idx === selectedTiffIndex ? { ...item, gender: e.target.value } : item
                                                    )
                                                }));
                                                setPlainTiffs(prev => {
                                                    const updated = [...prev];
                                                    updated[selectedTiffIndex] = {
                                                        ...updated[selectedTiffIndex],
                                                        personalInfo: {
                                                            ...updated[selectedTiffIndex].personalInfo,
                                                            gender: e.target.value
                                                        }
                                                    };
                                                    return updated;
                                                });
                                            }}
                                        />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <Field name={`painAndSufferingArr[${selectedTiffIndex}].monthlyamount`}
                                            label="Past Monthly Non-Economic Amount"
                                            placeholder="Enter amount"
                                            component={TextInput}
                                            shouldUserRenderIcon={<>   <span style={{ position: 'absolute', color: '#18479a', left: '12px', top: '8px' }}>$</span>    </>}
                                            shouldDollarRender={true}
                                            isDollarSignRender={true}

                                        />
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <Field name={`painAndSufferingArr[${selectedTiffIndex}].annualamount`}
                                            label="Future Annual Non-Economic Amount"
                                            placeholder="Enter amount"
                                            component={TextInput}
                                            shouldUserRenderIcon={<>   <span style={{ position: 'absolute', color: '#18479a', left: '12px', top: '8px' }}>$</span>    </>}
                                            shouldDollarRender={true}
                                            isDollarSignRender={true}
                                        />
                                    </div>
                                </div>
                            </div>
                            <h2 className="form-title mb-6 fs-4 pt-4 mt-2 border-top">Pain and Suffering Analysis
                            </h2>
                            <div className="form-group mb-10">
                                <div className='row report-section row-gap-60 m-0'>
                                    {painPoints.current.map((item,index) => (
                                        <div className="col-sm-6 col-md-4" key={index}>
                                            <p className="form-title mb-3">{item.category}</p>
                                            {item.points?.map((point,index) => (
                                                <div key={index}>
                                                    <FormControlLabel
                                                        label={point}
                                                        control={<Checkbox
                                                            sx={{ '& .MuiSvgIcon-root': { fontSize: 28, color: '#18479A' } }}
                                                            checked={values.painAndSufferingArr[selectedTiffIndex].selectedPainPoints.includes(point)}
                                                            onChange={() => {
                                                                const selectedPoints = values.painAndSufferingArr[selectedTiffIndex].selectedPainPoints;
                                                                if (selectedPoints.includes(point)) {
                                                                  setFieldValue(
                                                                    `painAndSufferingArr[${selectedTiffIndex}].selectedPainPoints`,
                                                                    selectedPoints.filter(item => item !== point)
                                                                  );
                                                                } else {
                                                                  setFieldValue(
                                                                    `painAndSufferingArr[${selectedTiffIndex}].selectedPainPoints`,
                                                                    [...selectedPoints, point]
                                                                  );
                                                                }
                                                              }}
                                                        />}
                                                    />
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div className="form-group mb-10">
                                <label className='label-style'> Describe any significant ways that your client’s life continues to be limited or affected presently as a result of any ongoing conditions from the incident </label>
                                <div className="input-field">
                                    <textarea value={bulletText[selectedTiffIndex]} name='descriptionText' onKeyDown={handleKeyDown} style={{ whiteSpace: 'pre-wrap', height: "14rem" }} ref={textareaRef} onChange={(e) => {
                                        setBulletText(prev => {
                                            const updated = [...prev];
                                            updated[selectedTiffIndex] = e.target.value;
                                            return updated;
                                        });
                                        }} placeholder='Write here...' className={`textarea-field-style`} />
                                </div>
                            </div>
                            <div className="row mb-3">
                                <div className="col-md-12">
                                    <label className="mb-2">Bodily Injury Photos
                                    </label>
                                    <XMultiImageUpload
                                        label="Bodily Injury Photos"
                                        name="bodilyInjuriesImageFiles"
                                        onChange={bodilyInjuriesFilesOnChange}
                                        initialFiles={bodilyInjuriesImageFiles[selectedTiffIndex]}
                                    />
                                </div>
                            </div>
                        </div>
                        <CaseFormFooter backToCases={backToCases} handlePrevious={handlePrevious} innerRef={innerRef}  formSteps={formSteps} values={values}/>
                    </div>
                </Form>
            )
            }
        </Formik >
    )
}

export default PainAndSufferingAnalysisForm;